import { DirectorUpdate, Director } from "@models/Director";
import { convertIdInArray, convertIdInObject } from "@util/convert-id-field";
import apiClient from "./apiClient";

interface DirectorWithId extends Omit<Director, "id"> {
    _id: string;
}

// Fetch all directors
export const fetchDirectors = async (): Promise<Director[]> => {
    try {
        const response = await apiClient.get<DirectorWithId[]>("/director");
        return convertIdInArray(response.data);
    } catch (error) {
        console.error("Failed to fetch user", error);
        throw error;
    }
};

// Fetch a single director by ID
export const fetchDirector = async (id: string): Promise<Director> => {
    try {
        const response = await apiClient.get<DirectorWithId>(`/director/${id}`);
        return convertIdInObject(response.data);
    } catch (error) {
        console.error("Failed to fetch user", error);
        throw error;
    }
};

// Create a new director
export const createDirector = async (director: DirectorUpdate): Promise<string> => {
    try {
        const response = await apiClient.post("/director", director);
        return response.data._id;
    } catch (error) {
        console.error("Failed to create user", error);
        throw error;
    }
};

// Update an existing director by ID
export const updateDirector = async (id: string, updates: DirectorUpdate): Promise<void> => {
    try {
        await apiClient.patch(`/director/${id}`, updates);
    } catch (error) {
        console.error("Failed to update user", error);
        throw error;
    }
};

// Soft delete a director by ID
export const deleteDirector = async (id: string): Promise<void> => {
    try {
        await apiClient.patch(`/director/${id}/delete`);
    } catch (error) {
        console.error("Failed to delete user", error);
        throw error;
    }
};
